import { ComponentPropsWithoutRef, FC } from 'react';

import Download from '@/assets/download.svg?react';
import Pdf from '@/assets/pdf.svg?react';

import Button from './ui/Button';
import { useLingui } from '@lingui/react';
import prettyBytes from 'pretty-bytes';

interface Props extends ComponentPropsWithoutRef<'div'> {
  name: string;
  onClick: () => void;
  size: number;
}

const DownloadBadge: FC<Props> = ({ name, onClick, size, ...props }) => {
  const { i18n } = useLingui();

  return (
    <div
      className="flex flex-col justify-between gap-4 rounded-xl bg-gray-100 p-4 text-center lg:flex-row lg:items-center lg:p-5"
      {...props}
    >
      <div className="flex items-center gap-3">
        <div className="size-[38px] rounded-lg bg-gray-200 p-2 lg:size-14 lg:p-3">
          <Pdf className="size-[22px] lg:size-8" />
        </div>
        <div className="text-left">
          <h5 className="font-semibold">{name}</h5>
          <p className="caption-large mt-1 text-dark-gray-300">
            PDF {prettyBytes(size)}
          </p>
        </div>
      </div>
      <Button size="small" onClick={onClick}>
        {i18n.t('Pobierz')}
        <Download className="size-[18px]" />
      </Button>
    </div>
  );
};

export default DownloadBadge;
